import { render } from "./Badge2.vue?vue&type=template&id=d6db6b1a&scoped=true"
import script from "./Badge2.vue?vue&type=script&lang=js"
export * from "./Badge2.vue?vue&type=script&lang=js"

import "./Badge2.vue?vue&type=style&index=0&id=d6db6b1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6db6b1a"]])

export default __exports__